

const LeetCodeDetails = () => {
    return (
        <div>
        <h1>LeetCode Details</h1>
        </div>
    );
    }


export default LeetCodeDetails;